// Imports
import { useStateValue } from '../../_global/jsx/store';
import { dangerousHTML, sendXHR, failedRequest } from 'src/lib/utils.js';
import { ReactPieChart } from '../../ReactPieChart/jsx/component.jsx';
import { ReactColourKey } from '../../ReactColourKey/jsx/component.jsx';


export const ReactDetailedAssessmentHub = () => {

    const [{ globalText, userData, controlData, questionData, questionSectionData, modalData }, dispatch] = useStateValue();

    // Click handler for Start/Continue buttons
    const clickHandler = (event) => {
        event.preventDefault();
        let fieldId = event.currentTarget.name;
        let appNameString = globalText.gaAppName;
        let sectionName = event.currentTarget.getAttribute('data-section');

        // fix for window.dataLayer undefined in Firefox
        window.dataLayer = window.dataLayer || [];
        
        if(getDALinkLabel(fieldId) === 'Start') {
            let appLabel = `Start topic - ${sectionName}`;
    
             window.dataLayer.push({"event": "interaction", "target": appNameString, "action": "button click", "label": (appLabel)}); 
        }

        if(getDALinkLabel(fieldId) === 'Review') {
            let appLabel = `Review topic - ${sectionName}`;
    
             window.dataLayer.push({"event": "interaction", "target": appNameString, "action": "button click", "label": (appLabel)}); 
        }
        
        dispatch({
            type: 'mainNavClick',
            value: { assetID: fieldId}
        });
    }

    // Get 
    const getRapidQsectionFromAssetID = (rQsectionAssetID) => {
        //filter out all but the rapid sections
        let rapidQsections = Object.values(questionSectionData).filter(
            (item) => {
                return item.assessmentType == "rapid";
            }
        )
        //find the rapid section by assetId from the passed parameter
        let rapidSection = rapidQsections.find((item) =>{
            return item.assetID == rQsectionAssetID;
        })

        return rapidSection;
    }

    // Get percentage score for the linked Rapid Assessment section
    const getUserResultsOfRapidQuestionSection = (rQsectionAssetID) => {
        let rapidQsection = getRapidQsectionFromAssetID(rQsectionAssetID);
        
        let sectionQuestions = rapidQsection.children;       
        let noOfQuestions = sectionQuestions.length;
        let totalScore = 0;
        sectionQuestions.forEach(question => {
            let rQassetID = question.assetID;
            let score = userData.questionResponses[rQassetID];

            if (score === 0) {
                totalScore++;
            } else if (score === 3) {
                noOfQuestions--;
            }
        });

        let percentage = totalScore / noOfQuestions * 100;
       // console.log("totalScore for section:",rapidQsection.navName ,totalScore);
        //console.log("percentage score for section:",rapidQsection.navName ,percentage);

        return percentage;
    }
 
    // Returns the progress of the relevant Detailed Question Section (not-started, in-progress or done)
    const getDAQuestionSectionProgress = (sectionID) => {
        let progressState = null;
        let sectionData = questionSectionData[sectionID];
        
        // If this nav item is a Question Section
        if (typeof(sectionData) !== 'undefined') {

            // If this nav item is a Detailed Question Section
            if (sectionData.assessmentType === 'detailed') {
                let sectionQuestions = sectionData.children;

                // If this nav item has children (ie. questions)
                if (typeof(sectionQuestions) !== 'undefined') {
                    progressState = 'not-started';

                    // If this is the current item then the section is in progress
                    if (sectionID === controlData.currentItem.topLevelAsset) {
                        progressState = 'in-progress';

                    // Else check how many questions are answered and compare with total
                    } else {

                        let noOfQuestions = sectionQuestions.length;
                        
                        let answeredQuestions = sectionQuestions.filter((question) => {
                            return userData.questionResponses.hasOwnProperty(question.assetID);
                        });
                        let noOfAnsweredQuestions = answeredQuestions.length;
                        
                        // If all questions are answered
                        if (noOfAnsweredQuestions === noOfQuestions) {
                            progressState = 'done';
                        
                        } else if (noOfAnsweredQuestions > 0) {
                            progressState = 'in-progress';
                        }
                    }
                }
            }
        }

        return progressState;
    }

    // Get link label for directing user to relevant Detailed Assessment Section (Eg. Start, Continue or Review)
    const getDALinkLabel = (sectionID) => {
        let label = 'Start';
        let progressState = getDAQuestionSectionProgress(sectionID);
        
        switch (progressState) {
            case 'not-started':
                label = 'Start';
                break;
            case 'in-progress':
                label = 'Continue';
                break;
            case 'done':
                label = 'Review';
                break;
        }

        return label;
    }

    const getDALink = (section) => {

        //if user scored 100% in rapid assessment do not link to the detailed assessment
        if(section.result === 100){
            return null;
        }

       return <div className="br-app-main-content__buttons__prev-next hide__prev-next__labels">
        <div className="br-app-main-content__buttons__next">
            <a href="#" name={section.assetID} data-section={section.navName} className="br-app-main-content__buttons__link" onClick={clickHandler}>
                <span className="br-app-main-content__buttons__link__text">{getDALinkLabel(section.assetID)}</span>
                
            </a>
        </div>
    </div>
    }

    // Render detail assessment hub tiles (based on each question section)
    const getAllDAQuestionSections = () => {
        let daQsections = Object.values(questionSectionData).filter(
            (item) => {
                return item.assessmentType == "detailed";
            }
        )
        

        // Calculate results for each section
        
        daQsections.forEach((section) => {
            if(section.linkedSection) {
                let percentageResult = getUserResultsOfRapidQuestionSection(section.linkedSection);
                section.result = percentageResult;
            }
        });

        // Sort by result in ascending order
        daQsections.sort((a, b) => {
            return a.result - b.result;
        });


        // Generate HTML
        return daQsections.map((section, idx1) => {
            let percentageResult = section.result;
            const questionSectionScore = userData.questionSectionScore[section.assetID];

            if ( typeof ( percentageResult ) !== 'undefined' ) {
                return (
                    <div key={"br-app-detail-hub__section--" + idx1} className="br-app-box">
                        
                        <div className="br-app-detail-hub__row">

                            <div className="br-app-detail-hub__col">
                                <ReactPieChart result={percentageResult} noColor={"true"} />
                            </div>
                            
                            <div className="br-app-detail-hub__col">
                                
                                <h2>{section.navName}</h2>
                                
                                <div dangerouslySetInnerHTML={dangerousHTML( section.detailHubContent )}></div>
                                
                                {getDALink( section )}
                            </div>
                            
                        </div>
                        
                    </div>
                );
            } else {
                return (
                    <div key={"br-app-detail-hub__section--" + idx1} className="br-app-box">
                        
                        <div className="br-app-detail-hub__row">
                            
                            <div className="br-app-detail-hub__col br-app-detail-hub__col-left">
                                
                                <h2>{section.navName}</h2>
                                
                                <div dangerouslySetInnerHTML={dangerousHTML( section.detailHubContent )}></div>
                                
                                {getDALink( section )}
                            </div>

                            <div className="br-app-detail-hub__col">
                                <ReactPieChart result={questionSectionScore} noColor={"true"} />
                            </div>
                            
                        </div>
                        
                    </div>
                );
            }
        })
    }

    
    return (
        <div>

            <div className={`${globalText.barChartRange_weakness == '' && globalText.barChartRange_strength == '' ? "hidden": ""}`}>
                <ReactColourKey />
            </div>

            {getAllDAQuestionSections()}

        </div>
    );
};
